export default __webpack_public_path__ + "static/media/instagram.9f5f02a5.svg";